export const teamExportColumns = [
	{ label: 'Sr No', key: 'index' },

	{
		label: 'Name',
		render: item => {
			const isHub = item?.userType === 'hub' || item?.hub
			const user = isHub ? item?.userId : item
			return `${user?.firstName || ''} ${user?.lastName || ''}`
		},
	},

	{
		label: 'Mobile',
		render: item => {
			const isHub = item?.userType === 'hub' || item?.hub
			const user = isHub ? item?.userId : item
			return user?.mobile || ''
		},
	},

	{
		label: 'Designation',
		render: item => {
			const isHub = item?.userType === 'hub' || item?.hub
			return isHub ? item?.designation || '' : item?.joinedSanstha?.[0]?.designation || ''
		},
	},

	{
		label: 'Permissions',
		render: item => {
			const isHub = item?.userType === 'hub' || item?.hub
			const perms = isHub ? item?.permissions : item?.joinedSanstha?.[0]?.permissions
			return Array.isArray(perms) ? perms.map(p => p.label).join(', ') : ''
		},
	},

	{
		label: 'Previous Committee',
		render: item => {
			const isHub = item?.userType === 'hub' || item?.hub
			return isHub
				? item?.inactive
					? 'Yes'
					: 'No'
				: item?.joinedSanstha?.[0]?.inactive
				? 'Yes'
				: 'No'
		},
	},

	{
		label: 'Duration',
		render: item => {
			const isHub = item?.userType === 'hub' || item?.hub
			const from = isHub ? item?.from : item?.joinedSanstha?.[0]?.from
			const to = isHub ? item?.to : item?.joinedSanstha?.[0]?.to
			return from || to ? `${from || ''} - ${to || ''}` : ''
		},
	},
]
